import React from 'react';
import { useAuth } from '../../../context/AuthContext';
import EmployeeAvatar from './EmployeeAvatar';
import '../../../components/clients/gallery/ClientGallery.css';
import { CardGridSkeleton } from '../../../components/loading/skeletons';
import './EmployeeGalleryExtras.css';

const EmployeeGallery = ({
  employees,
  onViewProfile,
  isLoading,
  emptyStateMessage,
  onInviteEmployee,
}) => {
  const { companyData } = useAuth();

  if (isLoading) {
    return (
      <div className="clientGallery employeeGallery">
        <CardGridSkeleton count={12} itemSize={72} label="Loading employees" />
      </div>
    );
  }

  if (employees.length === 0) {
    return (
      <div className="clientGallery employeeGallery">
        <div className="clientGalleryEmpty">
          <div className="clientGalleryEmptyIcon">👥</div>
          <h3>No employees found</h3>
          <p>{emptyStateMessage || 'Invite your team to get started'}</p>
          {onInviteEmployee && (
            <button type="button" className="clientGalleryAddBtn" onClick={onInviteEmployee}>
              Invite Employee
            </button>
          )}
        </div>
      </div>
    );
  }

  return (
    <div className="clientGallery employeeGallery">
      <div className="clientGalleryGrid">
        {employees.map((employee) => {
          const fullName = `${employee.firstName || ''} ${employee.lastName || ''}`.trim() || 'Team member';
          const roleLabel = employee.role ? String(employee.role) : 'Employee';

          return (
            <div key={employee.id} className="clientGalleryItem">
              <div
                className="clientGalleryItemMain"
                onClick={() => onViewProfile(employee.id)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    onViewProfile(employee.id);
                  }
                }}
                role="button"
                tabIndex={0}
                aria-label={`View ${fullName}`}
              >
                <div className="clientGalleryImageWrapper employeeGalleryImageWrapper">
                  <EmployeeAvatar
                    employee={employee}
                    companyData={companyData}
                    size="gallery"
                    alt={fullName}
                  />
                </div>
                <div className="clientGalleryName">{fullName}</div>
                <div className="employeeGalleryRole">{roleLabel}</div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default EmployeeGallery;
